// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export let AlertImportance = {
    HIGH: 1,
    MEDIUM: 5,
    LOW: 10
}
export let AlertImportanceMap = {
    1: "High",
    5: "Medium",
    10: "Low"
}